<template lang="pug">
  .firmware-status-filter
    span.filter-title {{ $t('transmitters.filters.firmware_status') }}
    el-select(
      v-model='selectedFirmwareStatus'
      filterable
      :placeholder="$t('placeholder.select_firmware_status')"
      @change="emitChangeEvent"
    )
      el-option(
        v-for='status in statuses'
        :key='status.value'
        :label='status.label'
        :value='status.value'
      )
</template>

<script>
export default {
  name: "FilterFirmwareStatus",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  computed: {
    selectedFirmwareStatus: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  data() {
    return {
      statuses: [
        { label: this.$t('common.all'), value: "" },
        { label: this.$t('transmitters.filters.outdated'), value: "outdated" },
        { label: this.$t('transmitters.filters.up_to_date'), value: "up_to_date" },
      ],
    };
  },

  methods: {
    emitChangeEvent(values) {
      this.$emit('onChange', values);
    },
  },
};
</script>
